'use strict';

module.exports = window.tgConfig;